var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ww-open-data',{attrs:{"type":_vm.openType,"openid":_vm.openId}})
}
var staticRenderFns = []

export { render, staticRenderFns }